import React, { useState, useEffect } from 'react';
import NumericKeypad from '../common/NumericKeypad';

const PriceEntryModal = ({ item, onConfirm, onCancel }) => {
  const [price, setPrice] = useState('');
  const [description, setDescription] = useState('');
  const [barcode, setBarcode] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (item) {
      setPrice('');
      setDescription('');
      setBarcode('');
      setError('');
    }
  }, [item]);

  if (!item) return null;

  const handleSubmit = (e) => {
    e?.preventDefault?.();
    const parsed = Number(price);
    if (Number.isNaN(parsed) || parsed <= 0) {
      setError('Enter a valid price greater than zero.');
      return;
    }
    const trimmedDescription = description.trim();
    const trimmedBarcode = barcode.trim();
    if (item?.isMiscProduct && !trimmedDescription) {
      setError('Enter product description for MISC/zero-priced item.');
      return;
    }
    onConfirm(item.productId, parsed, {
      ...item,
      miscDescription: trimmedDescription,
      miscBarcode: trimmedBarcode,
    });
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-6 space-y-4" onKeyDown={(e) => e.stopPropagation()}>
        <div>
          <h2 className="text-xl font-bold text-gray-900">Enter price</h2>
          <p className="text-sm text-gray-600">{item.name}</p>
        </div>
        <div className="text-center py-2">
          <p className="text-sm uppercase text-slate-500 tracking-wide">Amount</p>
          <p className="text-4xl font-semibold text-slate-900">${price || '0.00'}</p>
          {error && <p className="text-sm text-red-600 mt-1">{error}</p>}
        </div>
        {item?.isMiscProduct && (
          <div className="space-y-3">
            <div>
              <label htmlFor="misc-description" className="block text-xs font-semibold uppercase tracking-wide text-slate-500">
                Product Description
              </label>
              <input
                id="misc-description"
                type="text"
                value={description}
                onChange={(e) => {
                  setDescription(e.target.value);
                  if (error) setError('');
                }}
                placeholder="e.g. Gift wrap"
                className="mt-1 w-full rounded-xl border border-gray-300 px-3 py-2 text-sm text-slate-900 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary"
              />
            </div>
            <div>
              <label htmlFor="misc-barcode" className="block text-xs font-semibold uppercase tracking-wide text-slate-500">
                Barcode
              </label>
              <input
                id="misc-barcode"
                type="text"
                value={barcode}
                onChange={(e) => {
                  setBarcode(e.target.value);
                  if (error) setError('');
                }}
                placeholder="Scan or type barcode"
                className="mt-1 w-full rounded-xl border border-gray-300 px-3 py-2 text-sm text-slate-900 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary"
              />
            </div>
            <p className="text-xs text-slate-500">For MISC or zero-priced items, description is required. Barcode is optional.</p>
          </div>
        )}
        <NumericKeypad
          value={price}
          onChange={(next) => {
            setPrice(next);
            if (error) setError('');
          }}
          allowDecimal
        />
        <div className="flex gap-3 pt-2">
          <button
            type="button"
            onClick={() => onCancel(item.lineId || item.productId)}
            className="flex-1 rounded-xl border border-gray-300 py-3 font-semibold text-gray-700 hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSubmit}
            className="flex-1 rounded-xl bg-primary text-white py-3 font-semibold hover:bg-primary-dark"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default PriceEntryModal;
